import { getDocumentTypeDescription } from './documentTypeDescriptions';

const TEMPLATE_SEGMENT =
	/^(front matter|back matter|main|title page|abstract|references|appendix|acknowledgments?|table of contents|list of (tables|figures)|chapter \d+|dissertation template|thesis template|master'?s thesis|phd dissertation|honors thesis|academic research.*|thesis latest(\s*\d+)?|full title:?.*)$/i;

const TEMPLATE_BOILERPLATE =
	/\b(dissertation template|thesis template|front matter|back matter|title page|full title\s*:|approved title|match committee|committee forms|\[your\b|placeholder)\b/i;

/**
 * True when API description is structural template text, not user-authored summary.
 */
export function isTemplateStyleDescription(description) {
	if (!description || !String(description).trim()) return true;

	const text = String(description).trim();
	if (/thesis latest/i.test(text)) return true;
	if (/template/i.test(text) && text.includes(',')) return true;
	if (TEMPLATE_BOILERPLATE.test(text) && text.includes(',')) return true;
	if (/^dissertation template|^thesis template/i.test(text)) return true;
	if (/front matter/i.test(text) && /title page/i.test(text)) return true;
	if (/\[[^\]]{3,}\]/.test(text) && TEMPLATE_BOILERPLATE.test(text)) return true;

	const segments = text.split(/\s*,\s*/).map((s) => s.trim()).filter(Boolean);
	if (segments.length === 0) return true;

	const structuralCount = segments.filter(
		(seg) =>
			TEMPLATE_SEGMENT.test(seg) ||
			TEMPLATE_BOILERPLATE.test(seg) ||
			(seg.length < 50 && seg.split(/\s+/).length <= 5)
	).length;

	// Mostly structural comma-joined labels from old description builders
	if (segments.length >= 2 && structuralCount / segments.length >= 0.5) return true;

	const allStructural =
		segments.length >= 2 &&
		segments.every((seg) => seg.length < 45 && (TEMPLATE_SEGMENT.test(seg) || seg.split(/\s+/).length <= 4));

	return allStructural;
}

/**
 * Card body line: prefer user content snippet; fall back to document-type description.
 * Returns empty string when neither is useful (card can hide the line).
 */
export function getDocumentCardDescription({ description, documentType }) {
	if (!isTemplateStyleDescription(description)) {
		return String(description).trim();
	}
	return getDocumentTypeDescription(documentType) || '';
}
